<!--  -->
<template>
  <div>
    <a-modal
      :visible="visible"
      :footer="null"
      @cancel="handleCancel"
      :closable="true"
      :maskClosable="true"
      :width="544"
      :zIndex="100000"
      :bodyStyle="{
        zIndex: 99999,
        padding: 0,
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
        overflow: 'hidden',
      }"
    >
      <div>
        <div
          class="amall-alert-header flex-center text-white text-18 text-bold"
        >
          联系客服
        </div>
        <div class="amall-alert-box flex">
          <div style="">
            <img src="../../assets/icon/service_icon.png" style="width:127px;height:127px;" alt="">
          </div>
          <div class="flex flex-direction justify-center margin-left-lg padding-left"> 
            <div class="flex justify-start">
              <div class="text-block">统一热线：</div>
              <div class="text-yellow">400-880-8190</div>
            </div> 
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { findServiceListByTerm } from "@/service/user.js";
export default {
  props: {
    visible: {
      type: Boolean, //指定传入的类型
      default: false, //这样可以指定默认的值
    },
  },
  name: "",
  data() {
    return {
      value: "",
      radioStyle: {
        display: "flex",
        height: "50px",
        alignItems: "center",
        justifyContent: "flex-start",
      },
      serviveList: [],
      serviceName: "",
    };
  },
  created() {},
  methods: {
    confirm() {
      this.$emit("confirm", item);
    },
    searchService() {
      findServiceListByTerm({
        overTime: "",
        pageNum: 1,
        pageSize: 999,
        principalName: "",
        serviceName: this.serviceName,
        startTime: "",
      }).then((res) => {
        if (res.flag) {
          if (res.data.total > 0) {
            let arr = [];
            let hasArr = this.id;
            res.data.list.forEach((item) => {
              if (hasArr.indexOf(item.serviceId) == -1) arr.push(item);
            });
            this.value = arr[0].serviceId;
            this.serviveList = arr;
          } else {
            this.serviveList = [];
          }
        }
      });
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped lang='scss'>
.amall-alert-header {
  width: 100%;
  height: 50px;
  background: var(--amall-green);
}
.amall-alert-box {
  padding: 50px 80px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/amallService.vue